export default __webpack_public_path__ + "static/media/w4-circle.a77756a9.png";